import type { GameState, Piece } from '@sheshdash/shared';

// ADR-001 Phase 3: rules live on the server. The web client trusts the
// per-piece `is_playable` flag the backend stamps on every GAME_STATE.
// These helpers are thin guards that combine that flag with piece state
// — kept as named exports so call-sites read intentionally rather than
// poking at `piece.is_playable` directly.

function findPiece(gameState: GameState, playerId: string, pieceId: string): Piece | null {
  const player = gameState.players.find((p) => p.id === playerId);
  return player?.pieces.find((p) => p.id === pieceId) ?? null;
}

export function canPlacePieceByRules(gameState: GameState, playerId: string, pieceId: string): boolean {
  const piece = findPiece(gameState, playerId, pieceId);
  if (!piece || piece.state !== 'in_corner') return false;
  return piece.is_playable === true;
}

export function canMovePieceByRules(gameState: GameState, playerId: string, pieceId: string): boolean {
  const piece = findPiece(gameState, playerId, pieceId);
  if (!piece) return false;
  if (piece.state === 'in_corner' || piece.state === 'in_center') return false;
  return piece.is_playable === true;
}
